import {Loader, TextInput} from '@mantine/core';
import {BasicButton} from '@packages/ui';
import type {FC} from 'react';
import {isReleasedNewRegisterFlow} from '../../../../config/unReleasePage';
import type {ILogin} from '../../../../core/repositories/loginRepository';
import type {UseFormLoginReturnType} from '../LoginPage';

export type LoginFormContainerProps = {
  useFormLogin: UseFormLoginReturnType;
  submitLogin: (values: ILogin) => void;
  isLoading: boolean;
  hasError: boolean;
};

export const LoginForm: FC<LoginFormContainerProps> = ({
  useFormLogin,
  submitLogin,
  isLoading,
  hasError,
}) => {
  const isNewRegisterFlow = isReleasedNewRegisterFlow();

  return (
    <>
      {hasError && (
        <div className="bg-success-1 p-16 rounded-4 mb-8">
          <p className="text-base text-white font-bold">
            ・メールアドレスもしくはパスワードをご確認ください。
            {!isNewRegisterFlow && (
              <>
                <br />
                ・メールアドレスの認証がお済みでない場合、「大学のメールアドレス」でログインしてください。
                <br />
                ・メールアドレスの認証がお済みの場合は、「いつも使うメールアドレス」でログインしてください。
              </>
            )}
          </p>
        </div>
      )}
      <form
        onSubmit={useFormLogin.onSubmit((values) => {
          submitLogin(values);
        })}
      >
        <TextInput
          label=""
          type="email"
          placeholder="メールアドレス"
          className="mb-12"
          {...useFormLogin.getInputProps('email')}
        />
        <TextInput
          label=""
          type="password"
          placeholder="パスワード"
          className="mb-12"
          {...useFormLogin.getInputProps('password')}
        />
        {isLoading ? (
          <div className="flex justify-center items-center h-[45px]">
            <Loader color="gray" />
          </div>
        ) : (
          <BasicButton type="submit" isPrimary={false} isLarge={true}>
            ログインする
          </BasicButton>
        )}
      </form>
    </>
  );
};
